import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import { router } from './router';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './components/ui/Toast';
import { persistQueryCache } from './lib/persistedQuery';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

// Dashboard + session chooser paint from the last known result immediately,
// then refetch. See lib/persistedQuery.ts.
persistQueryCache(queryClient, ['active-sessions', 'dashboard-summary', 'content-readiness']);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
